// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"218":"b033d0db1cb26b4d8b80","308":"6b68fe1b4cb73e08d30e"}[chunkId] + ".bundle.js";
};